export default "__VITE_ASSET__DOHDuBWr__"